// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"ValidationsView_gridContainer__11wqY","onlyValidationPicture":"ValidationsView_onlyValidationPicture__2hFlF"};